/**
 * @desc 通过一级品类编号获取sku编号列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<string>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/getSkuNoListByPrimaryProductLine`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
